import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Inverse of ProtectedRoute — used to gate /login (and any other public-
// only routes) so that an already-authenticated user hitting the URL
// (via bookmark, deep link, back-button, or browser session restore)
// is redirected to the app before the login form ever mounts.
//
// While `AuthContext.loading` is still true, render the same lightweight
// spinner ProtectedRoute uses, matching the visual behaviour of the
// authenticated side. Once loading resolves:
//   - token present → redirect to `location.state?.from` (respecting the
//     path a ProtectedRoute redirected the user away from), else '/'.
//   - no token → let the child (LoginPage) render as usual.
const RedirectIfAuthed = ({ children }) => {
  const { token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (token) {
    const to = location.state?.from
      ? `${location.state.from.pathname}${location.state.from.search || ''}`
      : '/';
    return <Navigate to={to} replace />;
  }

  return children;
};

export default RedirectIfAuthed;
